import { createGlobalStyle } from 'styled-components';

export const GlobalStylesWithoutNavBarWithSafeArea = createGlobalStyle`
    :root {
        --bottom-bar-height-mobile: env(safe-area-inset-bottom, 0px);
    }
  `;

export const GlobalStylesWithNavBarWithoutSafeArea = createGlobalStyle`
    :root {
        --bottom-bar-height-mobile: 57px;
    }
  `;

export const GlobalStylesWithNavBarWithSafeArea = createGlobalStyle`  
    :root {
        --bottom-bar-height-mobile: calc(57px + env(safe-area-inset-bottom, 0px));
    }
  `;
